import { memo, useEffect, useState } from "react";
import { ShimmerCircularImage, ShimmerThumbnail } from "react-shimmer-effects";

const ImageComponent = ({
  src,
  onClick,
  compClassName,
  img_width,
  img_height,
  loader_width,
  loader_height,
  roundShimmerSize,
  border,
  borderRadius,
  boxShadow,
  trending,
  fallbackSrc,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [imageSrc, setImageSrc] = useState("");
  const getUserAgent = () => navigator.userAgent.toLowerCase();
  const userAgent = getUserAgent();

  const isFirefox = userAgent.includes('firefox');
  const isSafari = userAgent.includes('safari') && !userAgent.includes('chrome') && !userAgent.includes('chromium');
  const isChrome = userAgent.includes('chrome') && !userAgent.includes('edg');

  // Determine loading strategy based on browser
  const getLoadingStrategy = () => {
    if (isSafari || isFirefox) {
      return "eager"; // Safari and Firefox sometimes have issues with lazy loading
    }
    return "lazy";
  };
  useEffect(() => {
    const loadImage = () => {
      const imageToLoad = new Image();
      imageToLoad.src = src;
      imageToLoad.onload = () => {
        setImageSrc(src);
      };
      // No fallbackSrc passed keeps the old behavior (shimmer stays put on
      // failure) so every other caller of this shared component is
      // unaffected — only opts in when a caller explicitly passes one.
      imageToLoad.onerror = () => {
        if (fallbackSrc) {
          setImageSrc(fallbackSrc);
          setIsLoading(false);
        }
      };
    };

    loadImage();
  }, [src, fallbackSrc]);

  return (
    <>
      {isLoading && (
        <div
          className={`${compClassName} ${isLoading ? "d-block" : "d-none"}`}
          style={{
            height: loader_height,
            width: loader_width,
          }}
        >
          {compClassName?.includes("rounded-circle") ? (
            <ShimmerCircularImage
              size={roundShimmerSize || 25}
              className="p-0 m-0"
            />
          ) : (
            <ShimmerThumbnail center={true} fitOnFrame={true} rounded />
          )}
        </div>
      )}
      <img
        src={imageSrc}
        onClick={onClick}
        className={`${compClassName} ${isLoading ? "d-none" : "d-block"}`}
        style={{ border: border, boxShadow: boxShadow, width: trending ? img_width : "", borderRadius: borderRadius }}
        alt="..."
        loading={getLoadingStrategy()}
        width={img_width}
        height={img_height}
        onLoad={() => {
          setIsLoading(false);
        }}
        onError={(e) => {
          if (fallbackSrc && e.target.src !== fallbackSrc) {
            e.target.src = fallbackSrc;
          }
        }}
      />
    </>
  );
};

export default memo(ImageComponent);
